// 쪽지: 수정 횟수와 무관한 자유 메시지
export interface ProofNoteInput {
  message: string;
  attachment?: FileList;
}

// 수정요청 양식: 무료 횟수(3회) 차감, 초과 시 추가금 동의 필요
export interface ProofRevisionInput {
  items: RevisionItem[];
  message: string;
  attachment?: FileList;
  agreeExtraFee?: boolean;
}

// 서버 proofRouter의 REVISION_ITEMS와 같은 값
export type RevisionItem = 'TEXT' | 'IMAGE' | 'COLOR' | 'LAYOUT' | 'SIZE' | 'ETC';

export const REVISION_ITEM_OPTIONS: { value: RevisionItem; label: string }[] = [
  { value: 'TEXT', label: '문구 · 텍스트' },
  { value: 'IMAGE', label: '이미지 · 로고' },
  { value: 'COLOR', label: '색상' },
  { value: 'LAYOUT', label: '레이아웃 · 배치' },
  { value: 'SIZE', label: '사이즈 · 규격' },
  { value: 'ETC', label: '기타' },
];

export const REVISION_ITEM_LABEL = Object.fromEntries(REVISION_ITEM_OPTIONS.map((o) => [o.value, o.label])) as Record<
  RevisionItem,
  string
>;
